// removed by extract-text-webpack-plugin
module.exports = {"container":"_2sVXmXkTyTk-Xkmuxg5a5p","event-container":"_1UDmaj1npbKZ1mWGpNt6Wl","day-events":"_2QbdrH8e9H9AnjrNi09V1a","buttons-container":"j0J-Iqs1ysm_EQ8siksmO","button":"_2wiSaVHI6kAOB4AbVRIPoy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Calendar/components/Events.mod.css
// module id = 1028
// module chunks = 0